import { Button, Card, Center, Group, Stack, Text } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { IconPlus } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'
import { PipelineType } from '@/types/vlm'
import { generateUUID } from '@/utils/uuid'
import {
  createDefaultAction,
  getActionTypesForPipeline
} from '../vlmPipelineConfig'
import { ActionCard } from './ActionCard'
import { PipelineFormValues } from './VlmPipelineForm'

type PipelineActionsStepProps = {
  form: UseFormReturnType<PipelineFormValues>
}

export const PipelineActionsStep = ({ form }: PipelineActionsStepProps) => {
  const handleAddAction = () => {
    const [actionType] = getActionTypesForPipeline(
      form.values.pipelineType as PipelineType,
      form.values.source.patrolVideoSource
    )

    form.insertListItem('actions', {
      ...createDefaultAction(actionType),
      uuid: generateUUID(),
      isEditing: true
    })
  }

  // Only one action is ever mid-edit at a time: while one is open, adding
  // another would leave two incomplete panels open at once.
  const hasEditingAction = form.values.actions.some(
    (action) => action.isEditing
  )

  return (
    <Stack gap="md">
      {form.values.source.patrolMilestoneActionsRemoved && (
        <PlatformAlert variant="info" compact>
          <FormattedMessage id="vlm.pipelines.create.actions.milestoneRemoved" />
        </PlatformAlert>
      )}

      {form.values.actions.length === 0 ? (
        <Card padding="md" withBorder>
          <Center mih={120}>
            <Text size="sm" c="dimmed" ta="center">
              <FormattedMessage id="vlm.pipelines.create.actions.empty" />
            </Text>
          </Center>
        </Card>
      ) : (
        form.values.actions.map((action, index) => (
          <ActionCard key={action.uuid} form={form} index={index} />
        ))
      )}

      {!hasEditingAction && (
        <Group justify="flex-end">
          <Button
            variant="light"
            size="xs"
            leftSection={<IconPlus size={14} />}
            onClick={handleAddAction}
          >
            <FormattedMessage id="vlm.pipelines.create.actions.addButton" />
          </Button>
        </Group>
      )}
    </Stack>
  )
}
